var exports = {
  "jJ": "AppHeader__CiWNJh",
  "Gp": "AppHeaderLogo__mGeDqN",
  "N0": "AppHeaderTitle__w-4d_L",
  "UD": "buttonContainer__lxyvqk",
};

module.exports = exports;
